exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content[data-v-02fa2a7e]{width:980px;margin:0 auto}", ""]);

// exports
